const actions = {
  SET_STATE: 'refunds/SET_STATE',
  FETCH_ALL_REFUNDS: 'refunds/FETCH_ALL_REFUNDS',
  FETCH_REFUND_DETAIL: 'refunds/FETCH_REFUND_DETAIL',
}

export default actions
